module.exports = __webpack_public_path__ + "assets/img/Coolabah-Turf-Service-Page-w540.bcc08cbb.webp";